import { useQuery } from 'react-query';

import { faultQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IFaultAction } from '../../types/Fault/FaultCause';
import stubFaultActions from '../../stubs/FaultAction.json';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';

export default function useFaultAction(id: string) {
  const { get } = useApiHelper();

  const faultAction = useQuery({
    queryKey: faultQueryKeys.action(id),
    // queryFn: () =>
    //   // Return stub data wrapped in a promise to simulate async behavior
    //   Promise.resolve(stubFaultActions.find(action => action.id === id) as unknown as IFaultAction),

    // Uncomment below when API is ready:
    queryFn: () =>
      get<IDefaultResponseWithData<IFaultAction>>(
        `/v1/fault/actions/${id}`
      ).then((res) => res.data.data),
    enabled: !!id,
  });

  return {
    faultAction,
  };
}
